<template lang="pug">
.table-statement
  template(v-if="gameResultSlot")
    gameResultSlot(:list="gameResultList" :loading="loading" @refreshPage="refreshPage")
  template(v-else-if="gameResultCasino")
    gameResultCasino(:list="gameResultList" :loading="loading" @refreshPage="refreshPage")
  template(v-else-if="gameResultSports")
    gameResultSports(:list="gameResultList" :loading="loading" @refreshPage="refreshPage")
  template(v-else)
    .table-responsive
      table.table.table-new
        thead
          tr
            th {{ $t("ui.date") }}
            th {{ $t("ui.category") }}
            th {{ $t("ui.bet_count") }}
            th {{ $t("ui.winlose") }}
            th {{ $t("ui.turnover") }}
            th {{ $t("ui.valid_turnover") }}
        template(v-if="!loading")
          tbody(v-if="betHistory && betHistory.length > 0")
            tr(v-for="item in betHistory")
              td {{ workingDate }}
              td {{ item.provider_type }}
              td {{ item.bet_count }}
              td 
                a(href="javascript:void(0);" @click.stop="getMemberGameResult(item.provider_type)")
                  span(:class="$helpers.getNumberClass(item.winlose)") {{ $numeral(item.winlose).format("0,0.00") }}
                  i.fas.fa-chevron-circle-right(style="margin-left: 5px;")
              td
                span(:class="$helpers.getNumberClass(item.turnover)") {{ $numeral(item.turnover).format("0,0.00") }}
              td
                span(:class="$helpers.getNumberClass(item.valid_turnover)") {{ $numeral(item.valid_turnover).format("0,0.00") }}
          tbody(v-else)
            tr
              td(colspan=7) {{ $t('ui.no_record') }}
        template(v-else)
          tbody
            tr
              td(colspan=7) 
                i.fas.fa-sync.fa-spin
</template>
    
<script>
import config from '@/config'

export default {
  components: {
    gameResultSlot: () => import("@/components/gameresult/_gameresultslot"),
    gameResultCasino: () => import("@/components/gameresult/_gameresultcasino"),
    gameResultSports: () => import("@/components/gameresult/_gameresultsports")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      betHistory: [],
      gameResultSlot: false,
      gameResultCasino: false,
      gameResultSports: false,
      gameResultList: [],
      url: ""
    }
  },
  validations: { },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    workingDate() {
      return this.$store.getters.workingDate
    },
    pageSize() {
      return this.$store.getters.pageSize
    }
  },
  mounted(){
    if(this.workingDate) {
      this.dailyWinloseProvider()
    }
  },
  methods:{
    dailyWinloseProvider() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        let working_date = this.workingDate
        this.$store
          .dispatch("user/dailyWinloseProvider", { login_id, auth_token, working_date })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.betHistory = response.data
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
          })
      }
    },
    refreshPage(e) {
      this.getMemberGameResult(e.providerType, e.pageNumber)
    },
    getMemberGameResult(providerType, pageNumber){
      switch(providerType){
        case "LIVECASINO":
          this.gameResultSlot = false
          this.gameResultCasino = true
          this.gameResultSports = false
          this.url = config.getGameResultLivecasino()
          break;
        case "SLOTS":
          this.gameResultSlot = true
          this.gameResultCasino = false
          this.gameResultSports = false
          this.url = config.getGameResultSlot()
          break;
        case "SPORTSBOOK":
          this.gameResultSlot = false
          this.gameResultCasino = false
          this.gameResultSports = true
          this.url = config.getGameResultSports()
          break;
        default:
          break;
      }

      if (this.isLoggedIn) {
        let login_id = this.accountID
        let auth_token = this.sessionToken
        let url = this.url
        let working_date = this.workingDate
        let page_size = this.pageSize
        let page_number = pageNumber
        this.loading = true
        this.$store
          .dispatch("user/getMemberGameResult", { url, login_id, auth_token, working_date, page_size, page_number })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.gameResultList = response.data.gameresult
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            this.feedback.status = this.$t("error." + response.status)
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + response.status), "error")            
          })
      }
    }
  }
}
</script>